import { getCell, getColumnByCell, getRowIdentity } from './util'
import { getStyle, hasClass } from '../../../element/src/utils/dom'
// import ElCheckbox from '../../elCheckbox/src/checkbox.vue';
// import ElTooltip from '../../tooltip';
import debounce from 'throttle-debounce/debounce'
import LayoutObserver from './layout-observer'

export default {
  name: 'ElTableBody',

  mixins: [LayoutObserver],

  // components: {
  //     ElCheckbox,
  //     ElTooltip
  // },

  props: {
    store: {
      required: true,
    },
    stripe: Boolean,
    context: {},
    rowClassName: [String, Function],
    rowStyle: [Object, Function],
    fixed: String,
    highlight: Boolean,
    trRowHeight: Array,
  },

  render(h) {
    const columnsHidden = this.columns.map((column, index) => this.isColumnHidden(index))
    let rows = this.data
    if (this.store.states.lazy && Object.keys(this.store.states.lazyTreeNodeMap).length) {
      rows = rows.reduce((prev, item) => {
        prev.push(item)
        const rowKey = this.store.table.getRowKey(item)
        const parent = this.store.states.treeData[rowKey]
        if (parent && parent.children && parent.hasChildren) {
          const tmp = []
          const traverse = (children) => {
            if (!children) return
            children.forEach((key) => {
              tmp.push(this.store.states.lazyTreeNodeMap[key])
              if (this.store.states.treeData[key]) {
                traverse(this.store.states.treeData[key].children)
              }
            })
          }
          traverse(parent.children)
          prev = prev.concat(tmp)
        }
        return prev
      }, [])
    }
    // 每次渲染表格，获取下表格行的高度 （新增内容）
    this.$nextTick(() => {
      this.computeTrHeight()
    })
    return (
      <table class='el-table__body' cellspacing='0' cellpadding='0' border='0'>
        <colgroup>
          {this._l(this.columns, (column, cellIndex) => {
            return this.isColumnHidden(cellIndex) && this.fixed ? '' : <col name={column.id} />
          })}
        </colgroup>
        <tbody ref='pg-tbody' on-mouseleave={(_) => this.handleMouseLeave()}>
          {
            this._l(rows, (row, $index) => {
              const rowKey = this.table.rowKey ? this.getKeyOfRow(row, $index) : $index
              const treeNode = this.treeData[rowKey]
              const rowClasses = this.getRowClass(row, $index)
              if (treeNode) {
                rowClasses.push('el-table__row--level-' + treeNode.level)
              }
              const tr = (
                <tr
                  ref={`tableTr${$index}`}
                  v-show={treeNode ? treeNode.display : true}
                  style={
                    this.rowStyle ? this.getRowStyle(row, $index) : this.getRowHeight(row, $index)
                  }
                  key={rowKey}
                  on-dblclick={($event) => this.handleDoubleClick($event, row)}
                  on-click={($event) => this.handleClick($event, row, $index)}
                  on-contextmenu={($event) => this.handleContextMenu($event, row)}
                  on-mouseenter={(_) => this.handleMouseEnter($index)}
                  // on-mouseleave={ _ => this.handleMouseLeave($index) }
                  class={rowClasses}
                >
                  {this._l(this.columns, (column, cellIndex) => {
                    const { rowspan, colspan } = this.getSpan(row, column, $index, cellIndex)
                    if (this.isColumnHidden(cellIndex) && this.fixed) return ''
                    if (!rowspan || !colspan) {
                      return ''
                    } else {
                      const columnData = { ...column }
                      if (colspan !== 1) {
                        columnData.realWidth = columnData.realWidth * colspan
                      }
                      const data = {
                        store: this.store,
                        _self: this.context || this.table.$vnode.context,
                        column: columnData,
                        row,
                        $index,
                      }
                      if (cellIndex === this.firstDefaultColumnIndex && treeNode) {
                        data.treeNode = {
                          hasChildren:
                            treeNode.hasChildren || (treeNode.children && treeNode.children.length),
                          expanded: treeNode.expanded,
                          indent: treeNode.level * this.treeIndent,
                          level: treeNode.level,
                          loaded: treeNode.loaded,
                          rowKey,
                        }
                      }
                      return (
                        // <td title={this.needTitle ? this.getValueByPath(row, column.property) : ''}
                        <td
                          style={this.getCellStyle($index, cellIndex, row, column)}
                          class={this.getCellClass($index, cellIndex, row, column)}
                          rowspan={rowspan}
                          colspan={colspan}
                          on-mouseenter={($event) =>
                            this.handleCellMouseEnter($event, row, column.property, $index)
                          }
                          on-mouseleave={this.handleCellMouseLeave}
                        >
                          {this.isColumnHidden(cellIndex) && !this.fixed
                            ? ''
                            : column.renderCell.call(
                                this._renderProxy,
                                h,
                                data,
                                columnsHidden[cellIndex]
                              )}
                        </td>
                      )
                    }
                  })}
                </tr>
              )
              if (this.hasExpandColumn && this.store.isRowExpanded(row)) {
                return [
                  tr,
                  <tr>
                    <td colspan={this.columns.length} class='el-table__expanded-cell'>
                      {this.table.renderExpanded
                        ? this.table.renderExpanded(h, { row, $index, store: this.store })
                        : ''}
                    </td>
                  </tr>,
                ]
              } else {
                return tr
              }
            })
            /* .concat(
                            <el-tooltip effect={ this.table.tooltipEffect } placement="top" ref="tooltip" content={ this.tooltipContent }></el-tooltip>
                        ) */
          }
        </tbody>
      </table>
    )
  },

  computed: {
    table() {
      return this.$parent
    },

    data() {
      return this.store.states.data
    },

    treeData() {
      return this.store.states.treeData
    },

    columnsCount() {
      return this.store.states.columns.length
    },

    leftFixedLeafCount() {
      return this.store.states.fixedLeafColumnsLength
    },

    rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumnsLength
    },

    leftFixedCount() {
      return this.store.states.fixedColumns.length
    },

    rightFixedCount() {
      return this.store.states.rightFixedColumns.length
    },

    columns() {
      return this.store.states.columns
    },

    hasExpandColumn() {
      return this.columns.some(({ type }) => type === 'expand')
    },

    firstDefaultColumnIndex() {
      for (let index = 0; index < this.columns.length; index++) {
        if (this.columns[index].type === 'default') {
          return index
        }
      }
      return 0
    },

    treeIndent() {
      return this.store.states.indent
    },
    // （新加的，非源码）
    hoverRowIndex() {
      return this.store.states.hoverRow
    },
  },

  data() {
    return {
      trHeight: [],
      // needTitle: false,
      tooltipContent: '',
      preHoverRowIndex: null,
    }
  },

  created() {
    this.activateTooltip = debounce(50, (tooltip) => tooltip.handleShowPopper())
  },
  // 监听表格全局hover行行号 （非源码）
  watch: {
    hoverRowIndex() {
      const index = this.store.states.hoverRow
      if (index !== null) {
        const target = this.$refs['pg-tbody'].children[index]
        target && (target.className = target.className + ' hover-row')
      }
      if (this.preHoverRowIndex !== null) {
        const preTarget = this.$refs['pg-tbody'].children[this.preHoverRowIndex]
        preTarget && (preTarget.className = preTarget.className.replace(' hover-row', ''))
      }
      this.preHoverRowIndex = index
      this.computeTrHeight()
    },
  },
  methods: {
    getValueByPath(obj, path) {
      if (!obj || !path) return ''
      var tempObj = obj
      path = path.replace(/\[(\w+)\]/g, '.$1')
      path = path.replace(/^\./, '')
      var keyArr = path.split('.')
      var i = 0
      for (var len = keyArr.length; i < len - 1; ++i) {
        var key = keyArr[i]
        if (key in tempObj) {
          tempObj = tempObj[key]
        }
        if (!tempObj) return '-'
      }
      let result = tempObj[keyArr[i]]
      if (result === '' || result === undefined) {
        result = '-'
      } else if (typeof result === 'object') {
        result = ''
      }
      return result
    },
    getKeyOfRow(row, index) {
      const rowKey = this.table.rowKey
      if (rowKey) {
        return getRowIdentity(row, rowKey)
      }
      return index
    },

    isColumnHidden(index) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedLeafCount
      } else if (this.fixed === 'right') {
        return index < this.columnsCount - this.rightFixedLeafCount
      } else {
        return (
          index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount
        )
      }
    },

    getSpan(row, column, rowIndex, columnIndex) {
      let rowspan = 1
      let colspan = 1

      const fn = this.table.spanMethod
      if (typeof fn === 'function') {
        const result = fn({
          row,
          column,
          rowIndex,
          columnIndex,
        })

        if (Array.isArray(result)) {
          rowspan = result[0]
          colspan = result[1]
        } else if (typeof result === 'object') {
          rowspan = result.rowspan
          colspan = result.colspan
        }
      }

      return {
        rowspan,
        colspan,
      }
    },

    getRowStyle(row, rowIndex) {
      const rowStyle = this.table.rowStyle
      if (typeof rowStyle === 'function') {
        let resStyle = rowStyle.call(null, {
          row,
          rowIndex,
        })
        return { ...resStyle, height: this.trRowHeight[rowIndex] + 'px' }
      }
      return { ...rowStyle, height: this.trRowHeight[rowIndex] + 'px' }
    },

    getRowHeight(row, rowIndex) {
      if (this.trRowHeight) {
        return { height: this.trRowHeight[rowIndex] + 'px' }
      } else {
        return null
      }
    },

    getRowClass(row, rowIndex) {
      const classes = ['el-table__row']
      if (this.table.highlightCurrentRow && row === this.store.states.currentRow) {
        classes.push('current-row')
      }

      /*注释源码 if (rowIndex === this.store.states.hoverRow) {
                classes.push('hover-row');
            } */

      if (this.stripe && rowIndex % 2 === 1) {
        classes.push('el-table__row--striped')
      }
      const rowClassName = this.table.rowClassName
      if (typeof rowClassName === 'string') {
        classes.push(rowClassName)
      } else if (typeof rowClassName === 'function') {
        classes.push(
          rowClassName.call(null, {
            row,
            rowIndex,
          })
        )
      }

      if (this.store.states.expandRows.indexOf(row) > -1) {
        classes.push('expanded')
      }

      return classes
    },

    getCellStyle(rowIndex, columnIndex, row, column) {
      const cellStyle = this.table.cellStyle
      if (typeof cellStyle === 'function') {
        return cellStyle.call(null, {
          rowIndex,
          columnIndex,
          row,
          column,
        })
      }
      return cellStyle
    },

    getCellClass(rowIndex, columnIndex, row, column) {
      const classes = [column.id, column.align, column.className]

      if (this.isColumnHidden(columnIndex)) {
        classes.push('is-hidden')
      }

      const cellClassName = this.table.cellClassName
      if (typeof cellClassName === 'string') {
        classes.push(cellClassName)
      } else if (typeof cellClassName === 'function') {
        classes.push(
          cellClassName.call(null, {
            rowIndex,
            columnIndex,
            row,
            column,
          })
        )
      }

      return classes.join(' ')
    },

    handleCellMouseEnter(event, row, property, index) {
      const table = this.table
      const cell = getCell(event)
      if (cell) {
        const column = getColumnByCell(table, cell)
        const hoverState = (table.hoverState = { cell, column, row })
        table.$emit(
          'cell-mouse-enter',
          hoverState.row,
          hoverState.column,
          hoverState.cell,
          event,
          index
        )
      }

      // 判断是否text-overflow, 如果是就显示tooltip
      const cellChild = event.target.querySelector('.cell')
      if (!(hasClass(cellChild, 'el-tooltip') && cellChild.childNodes.length)) {
        return
      }
      // use range width instead of scrollWidth to determine whether the text is overflowing
      // to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3
      const range = document.createRange()
      range.setStart(cellChild, 0)
      range.setEnd(cellChild, cellChild.childNodes.length)
      const rangeWidth = range.getBoundingClientRect().width
      const padding =
        (parseInt(getStyle(cellChild, 'paddingLeft'), 10) || 0) +
        (parseInt(getStyle(cellChild, 'paddingRight'), 10) || 0)
      const needTitle =
        rangeWidth + padding > cellChild.offsetWidth ||
        cellChild.scrollWidth > cellChild.offsetWidth
      // 优化此处直接操作 DOM，避免vue 渲染整个表格 （新增）
      if (cell) cell.title = needTitle ? this.getValueByPath(row, property) : ''
      /* 源码 if ((rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) && this.$refs.tooltip) {
                const tooltip = this.$refs.tooltip;
                // TODO 会引起整个 Table 的重新渲染，需要优化
                this.tooltipContent = cell.innerText || cell.textContent;
                tooltip.referenceElm = cell;
                tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
                tooltip.doDestroy();
                tooltip.setExpectedState(true);
                this.activateTooltip(tooltip);
            } */
    },

    handleCellMouseLeave(event) {
      /*  const tooltip = this.$refs.tooltip;
            if (tooltip) {
                tooltip.setExpectedState(false);
                tooltip.handleClosePopper();
            } */
      const cell = getCell(event)
      if (!cell) return
      const oldHoverState = this.table.hoverState || {}
      this.table.$emit(
        'cell-mouse-leave',
        oldHoverState.row,
        oldHoverState.column,
        oldHoverState.cell,
        event
      )
    },

    handleMouseEnter(index) {
      this.store.commit('setHoverRow', index)
    },

    handleMouseLeave(index) {
      this.store.commit('setHoverRow', null)
    },

    handleContextMenu(event, row) {
      this.handleEvent(event, row, 'contextmenu')
    },

    handleDoubleClick(event, row) {
      this.handleEvent(event, row, 'dblclick')
    },

    handleClick(event, row, index) {
      this.store.commit('setCurrentRow', row)
      this.handleEvent(event, row, 'click', index)
    },

    handleEvent(event, row, name, index) {
      const table = this.table
      const cell = getCell(event)
      let column
      if (cell) {
        column = getColumnByCell(table, cell)
        if (column) {
          table.$emit(`cell-${name}`, row, column, cell, event, index)
        }
      }
      table.$emit(`row-${name}`, row, column, event, index)
    },

    handleExpandClick(row, e) {
      e.stopPropagation()
      this.store.toggleRowExpansion(row)
    },
    // 新增
    computeTrHeight() {
      if (['left', 'right'].indexOf(this.fixed) < 0) {
        let len = this.data ? this.data.length : 0
        let trHeight = [],
          trDom
        for (let i = 0; i < len; i++) {
          trDom = this.$refs[`tableTr${i}`]
          if (trDom) trHeight.push(trDom.offsetHeight || 40)
        }
        if (trHeight.some((im, index) => this.trHeight[index] !== im)) {
          // console.info('table render.....xxxxx');
          this.trHeight = trHeight
          this.$emit('tr-Height', trHeight)
        }
        trDom = null
      }
    },
  },
}
